"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepayRecordDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var RepayRecordDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RepayRecordDetail, _super);
    function RepayRecordDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷还款记录详情接口';
        _this.code = '101136';
        _this.desc = '现金贷还款记录详情接口';
        _this.requestParams = new cashLoanAuth_1.RepayRecordDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RepayRecordDetail;
}(service_1.BaseService));
exports.RepayRecordDetail = RepayRecordDetail;
//# sourceMappingURL=repayRecordDetail.js.map